export default "__VITE_ASSET__DzjWBrsP__"